module.exports = __webpack_public_path__ + "img/BlueSolid.a23714ab.png";